module.exports = __webpack_public_path__ + "de764d698820359b3e75e0f2b64d7369.pdf";